
  export default {
    mounted() {
      const chartData = JSON.parse(this.el.dataset.chartData || "[]")
      const i18n = JSON.parse(this.el.dataset.i18n || "null") || window.I18n || {}
      this.renderChart(chartData, i18n)
    },
    renderChart(chartData, i18n) {
      const t = (key) => i18n[key]
      if (chartData.length === 0) {
        this.el.innerHTML = `<div class="flex items-center justify-center h-full text-text-muted">${t("No attendance data available")}</div>`
        return
      }

      import("highcharts").then((Highcharts) => {
        const categories = chartData.map(d => d.name)
        const badgeInsData = chartData.map(d => d.avg_badge_ins)
        const headcountData = chartData.map(d => d.headcount)

        window.Enaia.applyHighchartsTheme(Highcharts.default)
        Highcharts.default.chart(this.el.id, {
          chart: {
            type: 'bar',
            backgroundColor: 'transparent'
          },
          title: { text: null },
          xAxis: {
            categories: categories,
            labels: {
              style: {
                fontSize: '12px',
                color: '#374151'
              }
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: t("People"),
              style: { fontSize: '12px' }
            }
          },
          legend: {
            enabled: true,
            align: 'center',
            verticalAlign: 'bottom'
          },
          tooltip: {
            shared: true,
            useHTML: true,
            formatter: function() {
              const location = this.x
              const badgeIns = this.points[0]?.y || 0
              const headcount = this.points[1]?.y || 0
              const rate = headcount > 0 ? ((badgeIns / headcount) * 100).toFixed(1) : 0
              return `<div style="padding: 8px;">
                <strong>${location}</strong><br/>
                ${t("Avg Badge-ins")}: ${Math.round(badgeIns)}<br/>
                ${t("Headcount")}: ${headcount}<br/>
                ${t("Attendance Rate")}: ${rate}%
              </div>`
            }
          },
          plotOptions: {
            bar: {
              borderRadius: 4,
              groupPadding: 0.1
            }
          },
          series: [{
            name: t("Avg Badge-ins"),
            data: badgeInsData,
            color: '#0086e6'
          }, {
            name: t("Headcount"),
            data: headcountData,
            color: '#E5E7EB'
          }],
          credits: { enabled: false }
        })
      })
    }
  }
